export default "__VITE_ASSET__e5536319__"